/**
 * This screen shows a message to user when a user logs out and also provides a button
 * to log-in again.
 */
import { Button, Container, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function Logout() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  function handleLogin() {
    navigate("/");
  }

  return (
    <Container maxWidth="xl" sx={{ paddingY: 2 }}>
      <Box
        minHeight="70vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Typography variant="h6">{t("logout.loggedOut")}</Typography>
        <Button variant="contained" size="large" onClick={handleLogin}>
          {t("logout.loginAgain")}
        </Button>
      </Box>
    </Container>
  );
}

export default Logout;
